import PropTypes from 'prop-types';
import React from 'react';
import ChairRentalAmount from './ChairRentalAmount';
import { chairRentalPaymentShape } from '../shapes';

const ChairRentalChargeableAmount = ({
  color,
  payment,
  markAsPaidOrCharge,
}) => (
  <div className="u-position-relative u-inline-block u-cursor-pointer">
    <ChairRentalAmount
      color={color}
      amount={payment && payment.amount}
      onClick={markAsPaidOrCharge}
    />
  </div>
);

ChairRentalChargeableAmount.propTypes = {
  color: PropTypes.string,
  payment: chairRentalPaymentShape,
  markAsPaidOrCharge: PropTypes.func.isRequired,
};

ChairRentalChargeableAmount.defaultProps = {
  color: 'red',
  payment: {},
};

export default ChairRentalChargeableAmount;

